<template>
  <div>
    <b-sidebar
      id="structure-operation-link-sidebar-right"
      class="production-orders-link-operations"
      right
      bg-variant="white"
      width="407px"
      v-model="isOpen"
      @hidden="closeModal"
    >
      <template #header>
        <div class="header-sidebar d-flex justify-content-between">
          <span class="sidebar-title">
            {{ $t(modalTitle) }}
          </span>

          <span
            class="close-icon"
            @click="closeModal()"
          >
            <CloseIcon />
          </span>
        </div>
        <div class="separator"></div>
      </template>
      <template>
        <div>
          <div class="text-block">
            <div class="title">{{ $t('OrdersPage.LinkOperation') }}</div>
            <div class="subtitle">
              {{
                `${$t('OrdersPage.SubTitleLinkModal')} ${routeName} ${$t(
                  'OrdersPage.SubTitleLinkModal2'
                )} `
              }}
            </div>
          </div>
          <div class="search-block">
            <span class="text">{{ $t('MaterialsPage.Operations') }}</span>
            <div class="search-input">
              <div class="div-custom-input input__structures">
                <div class="icon-block">
                  <SearchIcon class="search-icon" />
                </div>
                <b-form-tags
                  class="input-search-structures"
                  ref="formTagStructures"
                  v-model="filter.textFilter"
                  duplicate-tag-text=""
                  :placeholder="
                    filter.textFilter.length === 0 ? $t('SearchPlaceholderDefault') : ''
                  "
                  @input="(e) => updateFilter(e)"
                  remove-on-delete
                  add-on-change
                />
              </div>
            </div>
          </div>
          <div class="action-block">
            <div class="select-all">
              <div
                :class="['checkbox-container-operation', allOperationsChecked ? 'checked' : '']"
                @click="checkAllOperations()"
              >
                <span class="icon-checkbox"><CheckIcon /></span>
              </div>
              <span class="text">
                {{ $t('SelectAll') }}
              </span>
            </div>
          </div>
          <div
            class="operation-block"
            v-if="forceRenderLinkOperation"
          >
            <div
              v-if="filteredList.length === 0"
              class="block-no-results"
            >
              <div class="no-results">
                <SearchIcon />
                <p class="text">{{ $t('NoResultsFound') }}</p>
              </div>
            </div>
            <div v-else>
              <div
                v-for="operation in filteredList"
                :key="operation.id"
              >
                <div class="user-info-block">
                  <div class="check-operation">
                    <div
                      :class="[
                        'checkbox-container-operation __no-action-default',
                        operation.checked ? 'checked' : ''
                      ]"
                      @click="toggleCheckbox(operation)"
                    >
                      <span class="icon-checkbox __no-action-default"><CheckIcon /></span>
                    </div>
                  </div>
                  <div class="text-block">
                    <div class="operation-name">
                      {{ operation.name }}
                    </div>
                    <div class="operation-number">{{ operation.number }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="separator"></div>
        <b-col
          md="12"
          class="footer-sidebar"
        >
          <div class="d-flex buttons">
            <b-button
              class="btn-cancel btn-footer btn"
              @click="closeModal()"
            >
              {{ $t('RefuseStatus.Cancel') }}
            </b-button>
            <b-button
              class="btn-save btn-footer btn"
              @click="onLink()"
            >
              {{ $t('IntegrationPage.Link') }}
            </b-button>
          </div>
        </b-col>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
  import { BSidebar, BCol, BButton, BFormInput, BFormTags } from 'bootstrap-vue';
  import { mapState, mapMutations } from 'vuex';
  import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';

  export default {
    components: {
      BSidebar,
      BCol,
      BButton,
      BFormInput,
      BFormTags,
      ToastificationContent,
      CloseIcon: () => import('@core/assets/icons/close-icon.svg'),
      ArrowDown: () => import('@core/assets/icons/arrow-down-orange.svg'),
      CheckIcon: () => import('@core/assets/icons/check-icon.svg'),
      SearchIcon: () => import('@core/assets/icons/search-icon.svg')
    },
    props: {
      modalTitle: {
        type: String,
        default: ''
      },
      device: {
        type: String,
        default: 'desktop'
      },
      currentId: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        forceRenderLinkOperation: true,
        allOperationsChecked: false,
        isOpen: false,
        routeName: '',
        filter: {
          textFilter: []
        },
        filteredList: []
      };
    },
    mounted() {
      this.UPDATE_MODAL_LINK_OPERATIONS_TOGGLE(false);
    },
    methods: {
      ...mapMutations('app', ['UPDATE_FLAG_SHOW_OVERLAY']),
      ...mapMutations('productionOrders', [
        'UPDATE_MODAL_LINK_OPERATIONS_TOGGLE',
        'UPDATE_OPERATIONS_TO_LINK_LIST',
        'UPDATE_OPERATIONS_LIST'
      ]),
      closeModal() {
        this.UPDATE_MODAL_LINK_OPERATIONS_TOGGLE(false);
      },
      toggleCheckbox(elem) {
        if (!elem.checked) {
          elem['checked'] = true;
        } else {
          elem['checked'] = false;
        }
        this.verifyAllChecked();
        this.forceRenderLinkOperationList();
      },
      showToast(title, icon, text, variant) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: title,
            icon: icon,
            text: text,
            variant
          }
        });
      },
      unCheckAllOperations() {
        this.operationsToLink.map((e) => {
          e['checked'] = false;
        });
        this.allOperationsChecked = false;
      },
      updateFilter(e) {
        this.filteredList = this.operationsToLink;
        if (e.length === 0) return;

        const arr = this.filteredList;
        let filteredSet = new Set();

        e.forEach((filterValue) => {
          const regex = new RegExp(filterValue.toLowerCase(), 'i');
          arr.forEach((item) => {
            if (regex.test(item.name.toLowerCase())) {
              filteredSet.add(item);
            }
          });
        });

        this.filteredList = Array.from(filteredSet);
      },
      checkAllOperations() {
        this.filteredList.map((e) => {
          if (this.allOperationsChecked) {
            e['checked'] = false;
          } else {
            e['checked'] = true;
          }
        });
        this.verifyAllChecked();
        this.forceRenderLinkOperationList();
      },
      verifyAllChecked() {
        this.allOperationsChecked = this.filteredList.every((e) => e.checked);
      },
      forceRenderLinkOperationList() {
        this.forceRenderLinkOperation = false;
        this.$nextTick().then(() => {
          this.forceRenderLinkOperation = true;
        });
      },
      async getOperationsToLink() {
        this.UPDATE_FLAG_SHOW_OVERLAY(true);
        await this.$http2
          .get(`/api/myconfig/order/${this.currentId}/available-operations`)
          .then((response) => {
            this.UPDATE_OPERATIONS_TO_LINK_LIST(response.data.data.operations);
            this.routeName = response.data.data.routeName;
            this.filteredList = this.operationsToLink;
            this.forceRenderLinkOperationList();
            this.UPDATE_FLAG_SHOW_OVERLAY(false);
          })
          .catch((error) => console.error(error));
      },
      async onLink() {
        const hasChecked = this.filteredList.find((e) => e.checked);
        if (!hasChecked) return;
        this.UPDATE_FLAG_SHOW_OVERLAY(true);
        const checkedOperation = this.operationsToLink.filter((e) => !!e.checked);
        const payload = checkedOperation.map((e) => e.id);
        await this.$http2
          .post(`/api/myconfig/order/${this.currentId}/add-operations`, payload)
          .then((response) => {
            this.showToast(
              this.$t('IntegrationPage.success'),
              'SmileIcon',
              this.$t('OrdersPage.LinkedOperations'),
              'success'
            );
            this.closeModal();
            this.$emit('updateList');
          })
          .catch((error) => {
            error.response.data.errors.map((e) => {
              this.showToast(this.$t('Error'), 'FrownIcon', e.message, 'danger');
            });
          })
          .finally(() => this.UPDATE_FLAG_SHOW_OVERLAY(false));
      }
    },
    computed: {
      ...mapState('productionOrders', {
        isModalLinkOperationsOpen: 'isModalLinkOperationsOpen',
        operationsToLink: 'operationsToLink',
        operationList: 'operationList'
      })
    },
    watch: {
      isModalLinkOperationsOpen(v) {
        this.isOpen = v;
        this.unCheckAllOperations();
        if (v) {
          this.getOperationsToLink();
        } else {
          this.filter.textFilter = [];
        }
      }
    }
  };
</script>
<style lang="scss">
  .production-orders-link-operations {
    .b-sidebar.b-sidebar-right {
      transition: all 0.5s ease-out;
      border-left: 1px solid #cfc4be;
      @media (max-width: 814px) {
        width: 50vw !important;
      }
      @media (max-width: 480px) {
        width: 100vw !important;
      }
    }

    .separator {
      width: 100%;
      height: 1px;
      background: #cfc4be;
    }

    .b-sidebar {
      height: 100% !important;

      .b-sidebar-header {
        display: contents;

        .header-sidebar {
          width: 100%;
          padding: 16px;

          .sidebar-title {
            display: flex;
            align-items: center;
            color: #4c4541;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
          }

          .close-icon {
            border: 1px solid #974900;
            border-radius: 5px;
            width: 28px;
            height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            svg {
              width: 12px;
              height: 12px;
              path {
                fill: #974900;
              }
            }

            &:hover {
              background-color: #ffede2 !important;
            }

            &:active {
              background-color: #ffdbc4 !important;
            }
          }
        }

        .separator {
          width: 100%;
          height: 1px;
          background: #cfc4be;
        }
      }

      .b-sidebar-body {
        padding: 16px;
        overflow: hidden;

        .text-block {
          .title {
            color: #4c4541;
            font-size: 16px;
            font-weight: 600;
            line-height: 26px;
            padding-bottom: 8px;
          }

          .subtitle {
            color: #998f8a;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            padding-bottom: 16px;
          }
        }

        .search-block {
          .text {
            color: #4c4541;
            font-size: 16px;
            font-weight: 600;
            line-height: 26px;

            @media (max-width: 480px) {
              font-size: 14px;
              line-height: 20px;
            }
          }
          .search-input {
            display: flex;
            align-items: center;
            padding: 8px 0;

            .div-custom-input {
              display: flex;
              align-items: center;
              border-radius: 4px;
              width: 100%;
              overflow: hidden;
              border: 1px solid #cfc4be;
              .icon-block {
                display: flex;
                align-items: center;
                padding-left: 14px;
                height: 14px;
                .search-icon {
                  width: 14px;
                  height: 14px;
                  fill: #cfc4be;
                }
              }
              .input-search-structures {
                width: 100% !important;
                border: none;
                overflow: hidden;

                &.focus {
                  box-shadow: none;
                }
                &.b-form-tags {
                  padding: 0 !important;
                  display: flex;
                  align-items: center !important;
                  .b-form-tags-list {
                    width: 100% !important;
                    margin-left: 14px !important;
                    margin-top: 0;
                    height: 100% !important;
                    flex-wrap: nowrap !important;
                    display: flex !important;
                    align-items: center !important;
                    overflow: scroll;
                    overflow-y: hidden;
                    cursor: grabbing;
                    cursor: -webkit-grabbing;

                    &::-webkit-scrollbar {
                      display: none !important;
                    }
                    .b-form-tags-field {
                      margin: 9px 0;
                    }
                  }
                }

                .b-form-tags-button {
                  display: none;
                }

                .b-form-tag {
                  background-color: #974900;
                  margin-right: 0.6rem;
                  padding: 2px 8px !important;
                  font-size: 13px;
                }
              }
            }
          }
          .label-title {
            color: #4c4541;
            font-size: 16px;
            font-weight: 600;
            line-height: 26px;
            padding-bottom: 8px;
          }
        }

        .action-block {
          display: flex;
          justify-content: space-between;
          padding: 8px 0;

          .select-all {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 0 16px;

            .text {
              color: #4c4541;
              font-size: 14px;
              font-weight: 600;
              line-height: 20px;
            }
          }

          .function-filter .filter {
            color: #974900;
            font-size: 12px;
            font-weight: 600;
            line-height: 20px;
            letter-spacing: 0.15px;
          }

          .function-filter {
            display: flex;
            align-items: center;
            gap: 8px;
            color: #4c4541;
            font-size: 14px;
            font-weight: 600;
            line-height: 20px;

            .filter {
              display: flex;
              align-items: center;
              gap: 8px;
              padding: 4px 10px;
              border-radius: 5px;
              cursor: pointer;

              .arrow-down {
                width: 12px;
                height: 12px;
              }

              &:hover {
                background: #ffede2;
              }

              &:active {
                background: #ffdbc4;
              }
            }
          }

          @media (max-width: 480px) {
            flex-wrap: wrap;
          }
        }

        .operation-block {
          padding-bottom: 16px;
          overflow: auto;
          height: calc(100vh - 340px);

          &:has(.block-no-results) {
            overflow-y: hidden;
          }

          .block-no-results {
            height: 100%;
            padding: 16px 0;
            .no-results {
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 16px;
              border-radius: 6px;
              border: 1px solid #cfc4be;

              svg {
                width: 16px;
                height: 16px;
                fill: #998f8a;
              }

              .text {
                margin: 0;
                color: #998f8a;
                font-size: 16px;
                font-weight: 600;
                line-height: 26px;
              }

              @media (max-width: 480px) {
                svg {
                  width: 12px;
                  height: 12px;
                }
                .text {
                  font-size: 12px;
                  line-height: 16px;
                }
              }
            }
          }

          .user-info-block {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 7.5px 16px;
            overflow: hidden;
            border-bottom: 1px solid #eee;
            background: #fff;

            .picture img {
              width: 40px;
              border-radius: 50%;

              @media (max-width: 480px) {
                width: 30px;
              }
            }

            .check-operation {
              display: flex;

              .checkbox-container-operation {
                margin: 0;
              }
            }

            .text-block {
              overflow: hidden;
              .operation-name {
                color: #4c4541;
                font-size: 14px;
                font-weight: 600;
                line-height: 20px;
                white-space: nowrap;
                word-break: break-all;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .operation-number {
                color: #998f8a;
                font-size: 12px;
                font-weight: 400;
                line-height: 16px;
              }
            }
          }

          .roles-block {
            display: flex;
            justify-content: flex-end;
            gap: 8px;
            padding-right: 16px;
            margin-left: auto;
            .role-tag {
              white-space: nowrap;
              border-radius: 4px;
              background: #eceff1;
              padding-inline: 9px;
              color: #607d8b;
              text-align: center;
              font-size: 12px;
              font-weight: 600;
              line-height: 16px;
            }
          }

          &::-webkit-scrollbar {
            width: 7px;
          }

          &::-webkit-scrollbar-track {
            background: #fff;
          }

          &::-webkit-scrollbar-thumb {
            background-color: #cfc4be;
            border-radius: 9px;
          }
        }

        .checkbox-container-operation {
          display: flex;
          background-color: #fff;
          border: 1px solid #cfc4be;
          border-radius: 3px;
          cursor: pointer;
          width: 18px;
          height: 18px;

          .icon-checkbox {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 2px;
            svg {
              width: 12px;
              height: 12px;
            }
          }
          &.checked {
            background-color: #974900;
            display: block;
          }
        }

        &::-webkit-scrollbar {
          width: 7px;
        }

        &::-webkit-scrollbar-track {
          background: #fff;
        }

        &::-webkit-scrollbar-thumb {
          background-color: #cfc4be;
          border-radius: 9px;
        }
      }
    }

    .separator {
      width: 100%;
      height: 1px;
      background: #cfc4be;
    }

    .footer-sidebar {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 16px;

      .buttons,
      .edit-buttons {
        gap: 8px;
      }

      @media (max-width: 480px) {
        justify-content: center;
        .buttons {
          width: 100%;

          .btn {
            width: 50%;
          }
        }

        .btn-footer {
          font-size: 12px !important;
          padding: 3px 21px !important;
        }
      }

      .btn-footer {
        box-shadow: none;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        border-radius: 5px;

        &:hover {
          box-shadow: none;
        }

        &.btn-cancel {
          background-color: transparent !important;
          color: #974900 !important;
          border: 1px solid #974900 !important;
          padding: 8px 21px;

          &:hover {
            background-color: #ffede2 !important;
          }

          &:active {
            background-color: #ffdbc4 !important;
          }
        }

        &.btn-previous,
        &.btn-cancel.btn-cancel-outline {
          background-color: transparent !important;
          color: #974900 !important;
          border: 1px solid #974900 !important;
          padding: 8px 21px;

          &:hover {
            background-color: #ffede2 !important;
          }

          &:active {
            background-color: #ffdbc4 !important;
          }
        }

        &.btn-save {
          border: 1px solid #974900 !important;
          background-color: #974900 !important;
          color: #ffff !important;
          padding: 8px 21px;

          &:hover {
            background-color: #9f5714 !important;
          }

          &:active {
            background-color: #a45f1f !important;
          }
        }
      }
    }
  }
</style>
